import {
    mdiArrowLeft,
    mdiPackage,
    mdiArrowDownBoldBox,
    mdiApps,
    mdiArrowUpBoldBox,
    mdiAccount,
    mdiAccountBox,
    mdiAccountCancel,
    mdiAccountCheck,
    mdiAccountCircle,
    mdiDrag,
    mdiPuzzleOutline,
    mdiStorefrontOutline,
    mdiShapeOutline,
    mdiAccountGroup,
    mdiTrashCan,
    mdiContentDuplicate,
    mdiClipboardListOutline,
    mdiAlert,
    mdiAccountLock,
    mdiLinkOff,
    mdiInstagram,
    mdiMusicNote,
    mdiFacebook,
    mdiArrowDown,
    mdiRestore,
    mdiLightningBolt,
    mdiAlertDecagram,
    mdiNetwork,
    mdiLockClock,
    mdiCloudCog,
    mdiAccountMultiplePlus,
    mdiCalendarAlert,
    mdiWebhook,
    mdiCloudAlert,
    mdiUndo,
    mdiMessageOutline,
    mdiClockTimeThree,
    mdiShieldCheckOutline,
    mdiLockOutline,
    mdiTextBoxOutline,
    mdiMapMarkerOutline,
    mdiPhoneOutline,
    mdiEmailOutline,
    mdiMessageReplyOutline,
    mdiClipboardTextOutline,
    mdiClockTimeNine,
    mdiCalendarClock,
    mdiReceiptTextOutline,
    mdiFullscreen,
    mdiCheckBold,
    mdiDeleteOutline,
    mdiHomeOutline,
    mdiWeb,
    mdiDumbbell,
    mdiBank,
    mdiCommentQuoteOutline,
    mdiHelpCircleOutline,
    mdiArrowTopRightThick,
    mdiServerSecurity,
    mdiShieldPlus,
    mdiShieldCheck,
    mdiViewList,
    mdiArrowURightTopBold,
    mdiAccountOutline,
    mdiAccountPlus,
    mdiPause,
    mdiPhone,
    mdiMinus,
    mdiAdvertisements,
    mdiApple,
    mdiMonitor,
    mdiEmailSync,
    mdiAppleKeyboardCommand,
    mdiMessageText,
    mdiStar,
    mdiClipboardList,
    mdiArrowRight,
    mdiArrowRightThin,
    mdiAppleSafari,
    mdiArrowDownCircleOutline,
    mdiArrowTopRight,
    mdiArrowULeftTop,
    mdiArrowUpCircleOutline,
    mdiMapMarkerRadius,
    mdiBell,
    mdiBellOutline,
    mdiCalendarRemove,
    mdiBellRing,
    mdiCartPlus,
    mdiChatQuestion,
    mdiCheck,
    mdiCheckCircle,
    mdiChevronLeft,
    mdiDelete,
    mdiArrowCollapseLeft,
    mdiChevronRight,
    mdiArrowCollapseRight,
    mdiAccountCircleOutline,
    mdiChevronDown,
    mdiDeleteAlert,
    mdiChevronUp,
    mdiChartLine,
    mdiRefresh,
    mdiDownload,
    mdiLockCheck,
    mdiClockOutline,
    mdiMapMarker,
    mdiHistory,
    mdiClose,
    mdiPuzzle,
    mdiChip,
    mdiCodeJson,
    mdiCog,
    mdiSchool,
    mdiPlayCircleOutline,
    mdiFolderOpenOutline,
    mdiLifebuoy,
    mdiPlayCircle,
    mdiFolder,
    mdiScaleBalance,
    mdiShieldCrownOutline,
    mdiViewModuleOutline,
    mdiPlayBoxMultipleOutline,
    mdiMessageTextOutline,
    mdiImageMultipleOutline,
    mdiAccountArrowRightOutline,
    mdiBullhornOutline,
    mdiComment,
    mdiContentCopy,
    mdiCookie,
    mdiCpu64Bit,
    mdiCreditCard,
    mdiWrench,
    mdiCreditCardOutline,
    mdiConsole,
    mdiDatabase,
    mdiDesktopTowerMonitor,
    mdiSpeedometer,
    mdiFileImage,
    mdiDns,
    mdiLanConnect,
    mdiLanDisconnect,
    mdiFitToScreen,
    mdiDotsVertical,
    mdiDotsHorizontal,
    mdiContentSaveOutline,
    mdiEarth,
    mdiEmail,
    mdiPencilOutline,
    mdiEmailOpen,
    mdiEmailFast,
    mdiEthernet,
    mdiEthernetCable,
    mdiEye,
    mdiCloseCircle,
    mdiArrowLeftCircle,
    mdiArrowRightCircle,
    mdiEyeOff,
    mdiFilterVariant,
    mdiFrequentlyAskedQuestions,
    mdiCalendarRange,
    mdiRestart,
    mdiStopCircle,
    mdiTicketAccount,
    mdiPowerStandby,
    mdiTshirtCrewOutline,
    mdiPlayBoxMultiple,
    mdiCartOutline,
    mdiRhombusSplit,
    mdiFirefox,
    mdiServerOff,
    mdiFormatListBulletedType,
    mdiShieldLockOutline,
    mdiGamepadSquare,
    mdiTable,
    mdiGoogle,
    mdiLockReset,
    mdiImageMultiple,
    mdiViewGrid,
    mdiServerPlus,
    mdiTarget,
    mdiGoogleChrome,
    mdiHdmiPort,
    mdiHelp,
    mdiImage,
    mdiImageOutline,
    mdiCloudUploadOutline,
    mdiImageSizeSelectActual,
    mdiImageArea,
    mdiImageRemove,
    mdiImageRemoveOutline,
    mdiTwoFactorAuthentication,
    mdiInformation,
    mdiSend,
    mdiText,
    mdiFoodApple,
    mdiWeightLifter,
    mdiAccountTie,
    mdiInformationOutline,
    mdiCloudBraces,
    mdiArrowULeftTopBold,
    mdiSecurity,
    mdiInvoiceList,
    mdiContentSave,
    mdiIp,
    mdiPencilPlus,
    mdiTextBox,
    mdiTextBoxPlus,
    mdiFormatListGroup,
    mdiLinkVariant,
    mdiLinkedin,
    mdiLinux,
    mdiLock,
    mdiLogin,
    mdiLogout,
    mdiMagnify,
    mdiMapMarkerPath,
    mdiCalendarCheckOutline,
    mdiServerOutline,
    mdiMemory,
    mdiMicrosoftEdge,
    mdiMicrosoftWindows,
    mdiMonitorDashboard,
    mdiAlertOctagon,
    mdiMoonWaxingCrescent,
    mdiInvoiceText,
    mdiNas,
    mdiWallFire,
    mdiBug,
    mdiFileArrowLeftRightOutline,
    mdiHelpNetworkOutline,
    mdiAccountGroupOutline,
    mdiFileArrowLeftRight,
    mdiPalette,
    mdiPencil,
    mdiPlus,
    mdiPlusBox,
    mdiPlusBoxOutline,
    mdiPlay,
    mdiPower,
    mdiPowerCycle,
    mdiNoteAlert,
    mdiShieldAccount,
    mdiSendVariant,
    mdiReceiptText,
    mdiReceiptTextClock,
    mdiServer,
    mdiServerMinus,
    mdiServerNetwork,
    mdiSitemap,
    mdiShare,
    mdiShieldHome,
    mdiShieldLock,
    mdiCalendarCheck,
    mdiSwapHorizontal,
    mdiTabletCellphone,
    mdiThemeLightDark,
    mdiTranslate,
    mdiTimerSync,
    mdiTune,
    mdiPowerSleep,
    mdiPauseCircle,
    mdiRestartAlert,
    mdiTwitter,
    mdiUpdate,
    mdiViewDashboard,
    mdiLockQuestion,
    mdiWallet,
    mdiLan,
    mdiRouterNetwork,
    mdiCloudLock,
    mdiIpNetwork,
    mdiDesktopTower,
    mdiShield,
    mdiHomeGroup,
    mdiWeatherNight,
    mdiCloudDownload,
    mdiWeatherSunny,
    mdiController,
    mdiWebBox,
    mdiWhiteBalanceSunny,
    mdiWifi,
    mdiClipboardTextClock,
    mdiTicketConfirmation,
    mdiAppsBox,
    mdiTicketConfirmationOutline,
    mdiClipboardTextClockOutline,
    mdiCashMultiple,
    mdiCached,
    mdiCart,
    mdiListBox,
    mdiListBoxOutline,
    mdiCash,
    mdiHome,
    mdiCrown,
    mdiSeal
} from '@mdi/js';

// Export only the needed icons
export default {
    mdiLightningBolt,
    mdiArrowLeft,
    mdiPackage,
    mdiImageMultiple,
    mdiHomeOutline,
    mdiCrown,
    mdiAppsBox,
    mdiDumbbell,
    mdiListBoxOutline,
    mdiClipboardTextClockOutline,
    mdiClipboardTextClock,
    mdiCashMultiple,
    mdiTicketConfirmationOutline,
    mdiCash,
    mdiFoodApple,
    mdiWeightLifter,
    mdiAccountTie,
    mdiMapMarkerRadius,
    mdiListBox,
    mdiTable,
    mdiViewList,
    mdiViewGrid,
    mdiSpeedometer,
    mdiCloudCog,
    mdiSeal,
    mdiApps,
    mdiArrowDownBoldBox,
    mdiArrowUpBoldBox,
    mdiAccount,
    mdiFileArrowLeftRight,
    mdiShieldCheck,
    mdiAlert,
    mdiArrowLeftCircle,
    mdiArrowRightCircle,
    mdiAccountBox,
    mdiInstagram,
    mdiMusicNote,
    mdiFacebook,
    mdiArrowDown,
    mdiMessageOutline,
    mdiDesktopTower,
    mdiPencilOutline,
    mdiAccountCancel,
    mdiCloudDownload,
    mdiCartOutline,
    mdiServerSecurity,
    mdiAccountCheck,
    mdiLan,
    mdiReceiptTextOutline,
    mdiRouterNetwork,
    mdiClipboardList,
    mdiLanConnect,
    mdiCalendarRange,
    mdiRestart,
    mdiLanDisconnect,
    mdiFitToScreen,
    mdiCloudLock,
    mdiRhombusSplit,
    mdiIpNetwork,
    mdiTicketAccount,
    mdiPuzzleOutline,
    mdiLinkOff,
    mdiRestore,
    mdiShapeOutline,
    mdiCalendarRemove,
    mdiCalendarAlert,
    mdiCloudAlert,
    mdiUndo,
    mdiCalendarClock,
    mdiController,
    mdiShield,
    mdiHomeGroup,
    mdiAccountCircle,
    mdiAccountGroup,
    mdiAccountGroupOutline,
    mdiAccountLock,
    mdiAccountMultiplePlus,
    mdiAccountOutline,
    mdiAccountPlus,
    mdiDownload,
    mdiAdvertisements,
    mdiFullscreen,
    mdiPause,
    mdiCommentQuoteOutline,
    mdiHelpCircleOutline,
    mdiApple,
    mdiAppleKeyboardCommand,
    mdiAppleSafari,
    mdiLockCheck,
    mdiClockTimeThree,
    mdiClockTimeNine,
    mdiArrowDownCircleOutline,
    mdiArrowTopRight,
    mdiStopCircle,
    mdiArrowRight,
    mdiEmailSync,
    mdiMonitor,
    mdiShieldPlus,
    mdiArrowULeftTop,
    mdiCloudBraces,
    mdiDeleteOutline,
    mdiArrowUpCircleOutline,
    mdiContentSaveOutline,
    mdiBell,
    mdiBellOutline,
    mdiBellRing,
    mdiCartPlus,
    mdiMessageText,
    mdiViewDashboard,
    mdiSchool,
    mdiPlayCircleOutline,
    mdiFolderOpenOutline,
    mdiLifebuoy,
    mdiPlayCircle,
    mdiFolder,
    mdiPlayBoxMultiple,
    mdiScaleBalance,
    mdiImageOutline,
    mdiCloudUploadOutline,
    mdiShieldCrownOutline,
    mdiViewModuleOutline,
    mdiPlayBoxMultipleOutline,
    mdiMessageTextOutline,
    mdiImageMultipleOutline,
    mdiAccountArrowRightOutline,
    mdiStorefrontOutline,
    mdiBullhornOutline,
    mdiStar,
    mdiChatQuestion,
    mdiCheck,
    mdiCheckCircle,
    mdiChevronLeft,
    mdiArrowCollapseLeft,
    mdiImageSizeSelectActual,
    mdiChevronRight,
    mdiArrowCollapseRight,
    mdiTarget,
    mdiChevronDown,
    mdiSend,
    mdiText,
    mdiWallFire,
    mdiChevronUp,
    mdiClockOutline,
    mdiShieldCheckOutline,
    mdiLockOutline,
    mdiTextBoxOutline,
    mdiMapMarkerOutline,
    mdiPhoneOutline,
    mdiEmailOutline,
    mdiMessageReplyOutline,
    mdiClipboardTextOutline,
    mdiBank,
    mdiClose,
    mdiFormatListGroup,
    mdiCodeJson,
    mdiClipboardListOutline,
    mdiPuzzle,
    mdiChartLine,
    mdiChip,
    mdiCheckBold,
    mdiCog,
    mdiAlertDecagram,
    mdiNoteAlert,
    mdiShieldAccount,
    mdiNetwork,
    mdiTshirtCrewOutline,
    mdiLockClock,
    mdiArrowTopRightThick,
    mdiSecurity,
    mdiHistory,
    mdiArrowURightTopBold,
    mdiArrowRightThin,
    mdiComment,
    mdiWebhook,
    mdiContentCopy,
    mdiCookie,
    mdiArrowULeftTopBold,
    mdiCpu64Bit,
    mdiMinus,
    mdiCreditCard,
    mdiWeb,
    mdiCreditCardOutline,
    mdiFileImage,
    mdiLockReset,
    mdiDatabase,
    mdiDesktopTowerMonitor,
    mdiDns,
    mdiDotsVertical,
    mdiMapMarker,
    mdiPhone,
    mdiCalendarCheck,
    mdiCalendarCheckOutline,
    mdiEarth,
    mdiEmail,
    mdiConsole,
    mdiEmailOpen,
    mdiServerOff,
    mdiEmailFast,
    mdiLockQuestion,
    mdiEthernet,
    mdiShieldLockOutline,
    mdiFrequentlyAskedQuestions,
    mdiPowerStandby,
    mdiEthernetCable,
    mdiWrench,
    mdiEye,
    mdiEyeOff,
    mdiBug,
    mdiFilterVariant,
    mdiFirefox,
    mdiFormatListBulletedType,
    mdiGamepadSquare,
    mdiGoogle,
    mdiGoogleChrome,
    mdiHdmiPort,
    mdiHelp,
    mdiImage,
    mdiImageArea,
    mdiDotsHorizontal,
    mdiImageRemove,
    mdiImageRemoveOutline,
    mdiInformation,
    mdiTwoFactorAuthentication,
    mdiInformationOutline,
    mdiServerOutline,
    mdiInvoiceList,
    mdiDeleteAlert,
    mdiTrashCan,
    mdiCached,
    mdiContentDuplicate,
    mdiAlertOctagon,
    mdiPowerSleep,
    mdiPauseCircle,
    mdiRestartAlert,
    mdiIp,
    mdiLinkVariant,
    mdiLinkedin,
    mdiCloseCircle,
    mdiLinux,
    mdiDrag,
    mdiLock,
    mdiLogin,
    mdiLogout,
    mdiDelete,
    mdiMagnify,
    mdiContentSave,
    mdiMapMarkerPath,
    mdiMemory,
    mdiCart,
    mdiMicrosoftEdge,
    mdiMicrosoftWindows,
    mdiMonitorDashboard,
    mdiMoonWaxingCrescent,
    mdiNas,
    mdiHelpNetworkOutline,
    mdiPalette,
    mdiPencil,
    mdiPlus,
    mdiPlusBox,
    mdiPlusBoxOutline,
    mdiPlay,
    mdiPower,
    mdiFileArrowLeftRightOutline,
    mdiPowerCycle,
    mdiSendVariant,
    mdiReceiptText,
    mdiRefresh,
    mdiReceiptTextClock,
    mdiServer,
    mdiServerPlus,
    mdiServerMinus,
    mdiServerNetwork,
    mdiTextBoxPlus,
    mdiSitemap,
    mdiAccountCircleOutline,
    mdiShare,
    mdiShieldHome,
    mdiShieldLock,
    mdiSwapHorizontal,
    mdiTabletCellphone,
    mdiPencilPlus,
    mdiThemeLightDark,
    mdiTicketConfirmation,
    mdiTranslate,
    mdiTimerSync,
    mdiTune,
    mdiInvoiceText,
    mdiTwitter,
    mdiTextBox,
    mdiUpdate,
    mdiWallet,
    mdiWeatherNight,
    mdiWeatherSunny,
    mdiWebBox,
    mdiWhiteBalanceSunny,
    mdiWifi,
    mdiHome
}